import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fieldStyle, priority } from "../../utils/const2";
import { allLocation } from "../../redux/common/locationSlice";
import { FixedSizeList } from "react-window";
import { allSkill } from "../../redux/common/skillSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";

const renderVirtualizedList = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...rest } = props;

  return (
    <div ref={ref} {...rest}>
      <FixedSizeList
        height={300} // Adjust dropdown height
        width="100%"
        itemSize={46} // Height of each item
        itemCount={children.length}
      >
        {({ index, style }) =>
          React.cloneElement(children[index], {
            style: { ...style, top: `${style.top}px` },
            onMouseDown: (event) => {
              // Prevent closing on click
              event.preventDefault();
            },
          })
        }
      </FixedSizeList>
    </div>
  );
});

export default function SearchCandidateApply(props) {
  const { setSearchData, searchData } = props;

  const locations = useSelector((state) => state.location.data);
  const skillData = useSelector((state) => state.skill.data);
  const workautho = useSelector((state) => state.workautho.data);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
    dispatch(allSkill());
  }, []);

  return (
    <Grid container>
      <Grid item xs="12" sm="6" md="3" lg="3" sx={{ padding: "0 5px" }}>
        <Box>
          <Typography>Name</Typography>
          <TextField
            id="outlined-basic"
            type="text"
            variant="outlined"
            size="small"
            placeholder="Candidate"
            sx={{ backgroundColor: "#fff", width: "100%" }}
            name="full_name"
            value={searchData?.full_name || ""}
            onChange={(event) => {
              setSearchData((prev) => ({
                ...prev,
                full_name: event.target.value, // Updating consultant_name in searchData
              }));
            }}
          />
        </Box>
      </Grid>

      <Grid item xs="12" sm="6" md="3" lg="3" sx={{ padding: "0 5px" }}>
        <Box>
          <Typography>Visa</Typography>
          <Autocomplete
            multiple
            id="autocomplete-multi-select"
            options={workautho?.work_authorization_data || []}
            disableCloseOnSelect
            value={
              workautho?.work_authorization_data?.filter((skl) =>
                searchData.work_authorization?.includes(skl.id)
              ) || []
            }
            onChange={(event, value) => {
              // Update the `searchData` state when skills are selected
              const selectedLocationId = value?.map((skl) => skl?.id);
              setSearchData((prev) => ({
                ...prev,
                work_authorization: selectedLocationId,
              }));
            }}
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props}>
                <Checkbox
                  checked={selected}
                  sx={{ marginRight: 0, marginLeft: 0 }}
                />
                <span>{option?.name}</span>
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size="small"
                name="work_authorization"
                sx={fieldStyle}
                placeholder="Visa"
              />
            )}
            sx={{
              backgroundColor: "#fff",
              width: "100%",
            }}
          />
        </Box>
      </Grid>

      <Grid item xs="12" sm="6" md="3" lg="3" sx={{ padding: "0 5px" }}>
        <Box>
          <Typography>Location</Typography>
          <Autocomplete
            multiple
            id="autocomplete-multi-select"
            options={locations?.locations || []}
            disableCloseOnSelect
            value={
              locations?.locations?.filter((skl) =>
                searchData.current_location?.includes(skl.id)
              ) || []
            }
            onChange={(event, value) => {
              // Update the `searchData` state when skills are selected
              const selectedLocationId = value?.map((skl) => skl?.id);
              setSearchData((prev) => ({
                ...prev,
                current_location: selectedLocationId, // Update the skills array in searchData
              }));
            }}
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props}>
                <Checkbox
                  checked={selected}
                  sx={{ marginRight: 0, marginLeft: 0 }}
                />
                <span>{option?.name}</span>
              </MenuItem>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                // label="Location"
                variant="outlined"
                size="small"
                name="current_location"
                sx={fieldStyle}
                placeholder="Location"
              />
            )}
            sx={{
              backgroundColor: "#fff",
              width: "100%",
            }}
          />
        </Box>
      </Grid>

      <Grid item xs="12" sm="6" md="3" lg="3" sx={{ padding: "0 5px" }}>
        <Box>
          <Typography>Skill</Typography>
          <Autocomplete
            multiple
            id="autocomplete-multi-select"
            options={skillData?.locations || []}
            disableCloseOnSelect
            value={
              skillData?.locations?.filter((skl) =>
                searchData.skills?.includes(skl.id)
              ) || []
            }
            onChange={(event, value) => {
              // Update the `searchData` state when skills are selected
              const selectedLocationId = value?.map((skl) => skl?.id);
              setSearchData((prev) => ({
                ...prev,
                skills: selectedLocationId, // Update the skills array in searchData
              }));
            }}
            getOptionLabel={(option) => option?.name || ""}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props}>
                <Checkbox
                  checked={selected}
                  sx={{ marginRight: 0, marginLeft: 0 }}
                />
                <span>{option?.name}</span>
              </MenuItem>
            )}
            ListboxComponent={renderVirtualizedList}
            renderInput={(params) => (
              <TextField
                {...params}
                // label="Location"
                variant="outlined"
                size="small"
                name="skills"
                sx={fieldStyle}
                placeholder="Skill"
              />
            )}
            sx={{
              backgroundColor: "#fff",
              width: "100%",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
